import { searchCountryWithPagination } from '../../../../services/api/CountryApi';
import { countrySearchActions as searchPageSliceActions } from '../slices/countrySearchSlice';
import { ObjectTypes } from '../../../../utils/constants';
import { doSearchStoreAction, loadGridColumnSettingStoreAction, loadSavedFilterStoreAction } from '../../../Generic/SearchPage/actions/searchPageActions';

const getStateSliceForSearchPage = (state) => state.countrySearch;

export const loadGridColumnSettingStoreActionHandler = () => async (dispatch, getState) => loadGridColumnSettingStoreAction({ dispatch, getState, searchPageSliceActions, getStateSliceForSearchPage, objectTypeGridColumns: ObjectTypes.CountriesSearchGrid });

export const loadSavedFilterStoreActionHandler = () => async (dispatch, getState) => loadSavedFilterStoreAction({ dispatch, getState, searchPageSliceActions, getStateSliceForSearchPage, objectTypeForSaveUserFilter: ObjectTypes.CountriesSearchSavedUserFilter });

export const doSearchStoreActionHandler = () => async (dispatch, getState) => {
  const searchParamBuilder = (filter) => ({
    CountryName: filter.CountryName || '',
    CountryCode: filter.CountryCode || '',
    CountryCode2: filter.CountryCode2 || '',
    CountryNumericCode: filter.CountryCode2 || '',
    Active: filter.Active,
  });

  await doSearchStoreAction({ dispatch,
    getState,
    searchPageSliceActions,
    getStateSliceForSearchPage,
    searchParamBuilder,
    searchWithPaginationApi: searchCountryWithPagination,
    postResultsProcessHandler: null
  });
};
